import LazyGravityForm from '../../fragments/gravity-form/LazyGravityForm';
import ComponentWrapper from '../../fragments/component-wrapper/ComponentWrapper';
import useGravityForm, { GRAVITY_FORM_HELPER_TEXT } from './useGravityForm';
import ComponentHeading from '../../fragments/heading/ComponentHeading';
import ContactDetails from './ContactDetails';
// import RecaptchaNotice from '../../fragments/recaptcha-notice/RecaptchaNotice';

export default function GravityForm({ block, gravityForms }) {
  const gravityForm = useGravityForm({ block, gravityForms });

  if (!gravityForm.hasValidConfig) {
    if (process.env.NODE_ENV !== 'production') {
      return (
        <ComponentWrapper block={block} className="BlockGravityForm">
          <p>Gravity Form is not configured or could not be loaded.</p>
        </ComponentWrapper>
      );
    }

    return null;
  }

  const {
    formData,
    formId,
    graphFormId,
    saveAndContinueSettings,
    hasSaveAndContinue,
    hasRequiredFields,
    presetValues,
    customFormFields,
    totalPages,
    currentPage,
    progressPercentage,
    shouldHoldFormRenderForRestore,
    isRestoringDraft,
    draftRestoreError,
    formRenderKey,
    setFormInstance,
    handleFormValidationCapture,
    handleFormSubmitSuccess,
    handleFormSubmitError,
    hasSubmittedForm,
    isSavingDraft,
    draftError,
    draftResumeUrl,
    draftMessage,
    handleSaveAndContinue,
    handleCopyResumeLink,
  } = gravityForm;

  return (
    <ComponentWrapper block={block} className="BlockGravityForm">
      {block.heading && (
        <div className={'l-grid'}>
          <ComponentHeading heading={block.heading} />
        </div>
      )}
      <div className={'l-grid'}>
        <div className="l-grid__col l-grid__col--l-5-12">
          <ContactDetails block={block} />
        </div>
        <div className="l-grid__col l-grid__col--l-6-12 l-grid__col--l-push-1-12">
          {totalPages > 1 && (
            <div
              className="BlockGravityForm-progress"
              style={{ marginBottom: '1rem' }}
            >
              <p
                className="BlockGravityForm-progressLabel"
                style={{ margin: '0 0 0.375rem', fontSize: '0.875rem' }}
              >
                Step {currentPage} of {totalPages}
              </p>
              <div
                className="BlockGravityForm-progressTrack"
                role="progressbar"
                aria-valuemin={1}
                aria-valuemax={totalPages}
                aria-valuenow={currentPage}
                aria-label={`Form progress: step ${currentPage} of ${totalPages}`}
                style={{
                  width: '100%',
                  height: '0.375rem',
                  borderRadius: '999px',
                  backgroundColor: '#e5e7eb',
                  overflow: 'hidden',
                }}
              >
                <div
                  className="BlockGravityForm-progressFill"
                  style={{
                    width: `${progressPercentage}%`,
                    height: '100%',
                    backgroundColor: '#111827',
                    transition: 'width 200ms ease',
                  }}
                />
              </div>
            </div>
          )}
          {hasRequiredFields && (
            <p className="BlockGravityForm-requiredTip">
              <span aria-hidden="true">*</span> Required field
            </p>
          )}
          {!shouldHoldFormRenderForRestore && (
            <div
              className={`BlockGravityForm-form `}
              onClickCapture={handleFormValidationCapture}
              onSubmitCapture={handleFormValidationCapture}
            >
              <LazyGravityForm
                formKey={formRenderKey}
                formRef={setFormInstance}
                minHeight={480}
                data={formData}
                successCallback={handleFormSubmitSuccess}
                errorCallback={handleFormSubmitError}
                helperText={GRAVITY_FORM_HELPER_TEXT}
                presetValues={presetValues}
                customFormFields={customFormFields}
              />
              {/* <RecaptchaNotice /> */}
            </div>
          )}
          {(isRestoringDraft || shouldHoldFormRenderForRestore) && (
            <p style={{ marginTop: '0.75rem' }}>Restoring saved progress...</p>
          )}
          {draftRestoreError && (
            <p role="alert" style={{ marginTop: '0.75rem' }}>
              {draftRestoreError}
            </p>
          )}
          {hasSaveAndContinue && !hasSubmittedForm && (
            <div
              className="BlockGravityForm-saveAndContinue"
              style={{ marginTop: '1rem' }}
            >
              <button
                type="button"
                className="button"
                onClick={handleSaveAndContinue}
                disabled={isSavingDraft || isRestoringDraft}
              >
                {isSavingDraft
                  ? 'Saving...'
                  : saveAndContinueSettings?.buttonText ||
                    'Save and continue later'}
              </button>

              {draftError && (
                <p role="alert" style={{ marginTop: '0.5rem' }}>
                  {draftError}
                </p>
              )}

              {draftResumeUrl && (
                <div style={{ marginTop: '0.75rem' }}>
                  <label
                    htmlFor={`gform_resume_url_${formId}`}
                    style={{ display: 'block' }}
                  >
                    Resume link
                  </label>
                  <input
                    id={`gform_resume_url_${formId}`}
                    type="text"
                    readOnly
                    value={draftResumeUrl}
                    style={{ width: '100%' }}
                  />
                  <button
                    type="button"
                    className="button"
                    onClick={handleCopyResumeLink}
                    style={{ marginTop: '0.5rem' }}
                  >
                    Copy link
                  </button>
                  {draftMessage && (
                    <p style={{ marginTop: '0.5rem' }}>{draftMessage}</p>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </ComponentWrapper>
  );
}
